import { Component, Event, EventEmitter, h, Host, Prop, State } from '@stencil/core';

@Component({
  tag: 'input-field-component',
  styleUrl: 'input-field-component.scss',
  shadow: true,
})
export class RealEstateFillComponent {
  @Prop({ reflect: true, mutable: true }) label: string;
  @Prop({ reflect: true, mutable: true }) value: string;
  @Prop() linkText: string = '';
  @Prop() linkUrl: string = '';
  @Prop() placeHolder: string = '';
  @Prop() helperText: string = '';
  @Prop() errorMessage: string = '';
  @Prop() anyIcon: string = '';
  @Prop() isDisabled: boolean = false;
  @Prop() isError: boolean = false;
  @State() isFocused: boolean = false;
  @Event() valueChanged: EventEmitter<string>;
  @Event() linkClicked: EventEmitter<string>;
  @Event() blurred: EventEmitter<void>;
  @Prop() labelId: string | undefined;
  @Prop() name: string | undefined;
  @Prop() autocomplete: string | undefined;

  private inputElement?: HTMLInputElement;

  handleFocus() {
    this.isFocused = true;
  }

  handleBlur() {
    this.isFocused = false;
    this.blurred.emit();
  }

  clearInput(event: MouseEvent) {
    event.preventDefault();
    this.value = '';
    this.valueChanged.emit(this.value);
    setTimeout(() => this.inputElement?.focus(), 0);
  }

  handleInputChange(event: InputEvent) {
    this.value = (event.target as HTMLInputElement).value;
    this.valueChanged.emit(this.value);
  }

  handleLinkClicked() {
    this.linkClicked.emit();
  }

  render() {
    return (
      <Host>
        <label class="label" htmlFor={this.labelId}>
          {this.label}
        </label>
        <div
          class={`input-row ${this.isFocused ? 'is-focused' : ''} 
                      ${this.isError ? 'is-error' : ''}`}
        >
          {this.value === '' ? (
            <i class="material-icons-outlined any-icon">{this.anyIcon}</i>
          ) : (
            <i class="material-icons-outlined close-icon" onMouseDown={event => this.clearInput(event)}>
              close
            </i>
          )}
          <input
            ref={el => (this.inputElement = el as HTMLInputElement)}
            type="text"
            id={this.labelId}
            name={this.name}
            placeholder={this.placeHolder}
            value={this.value}
            disabled={this.isDisabled}
            onFocus={() => this.handleFocus()}
            onBlur={() => this.handleBlur()}
            onInput={event => this.handleInputChange(event)}
          />
        </div>
        <div class="text">
          {this.isError ? (
            <div class="error">
              <i class="material-icons-outlined error-icon">error</i>
              <span class="error-message"><p innerHTML={this.errorMessage}></p></span>
            </div>
          ) : (
            this.helperText + ' '
          )
          }
          {this.linkText && (
            <a class="link" onClick={() => this.handleLinkClicked()}>
              {this.linkText}
            </a>
          )}

        </div>
      </Host>
    );
  }
}
